// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> alpine
// Generated: 2026-11-02T18:12:18.166Z
// Counts: 0 design, 28 content, 15 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>The heart of a growing community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>A Premier Downtown Destination</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-3764-7428-97af-b3d96baa5c3c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious community lounge with fireplace, seating, and large windows."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-370c-7519-a48d-701943296b77.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A well-equipped fitness center with treadmills and elliptical machines."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-0260-731c-9f92-c5ea08d8ca25.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room and kitchen area with sofa, coffee table, dining table, chairs, and kitchen appliances."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-40e5-73f6-bd4f-29b7bce71265.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lobby area with large windows, seating, and reception desk."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-0162-723c-acd3-8f0bb9761395.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room and kitchen area of an apartment with furniture and appliances."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-4598-7130-b04a-85186b66f2be.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community lounge area with coffee bar and seating."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-5298-76af-912d-32e4f5d6d484.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced-in dog park with green grass and apartment buildings in the background."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-0e94-74cf-8b4c-49a774b8ad72.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with wooden cabinets, double sink, dishwasher, and dining area."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-1fb4-714a-979e-e93522615e2b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen-size bed, decorative headboard, two nightstands, and a large mirror."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-0427-716b-8a73-3da805a3abf7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with sofa, armchair, coffee table, and large window."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
